import React from 'react';

import type { FacebookStoryComponentsProps } from './types';

export function Footer(_props: FacebookStoryComponentsProps): React.JSX.Element {
	return <div>Facebook Story Footer</div>;
}
